<template>
  <v-flex xs12 sm3 v-if="topic">
    <TopicDetailPanel :topic="topic"></TopicDetailPanel>
    <TopicCommentPanel :topic="topic"></TopicCommentPanel>
  </v-flex>
</template>

<script>
import TopicDetailPanel from '@/components/topic/TopicDetailPanel.vue';
import TopicCommentPanel from '@/components/topic/TopicCommentPanel.vue';

export default {
  name: 'TopicCard',
  components: {
    TopicDetailPanel,
    TopicCommentPanel,
  },
  props: {
    topic: Object,
  },
};
</script>
